import { Stack } from 'braid-design-system';
import { JobCategoryLookup } from 'wingman-fe';

import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';

export const JobCategoryLookupSection = () => {
  const { seekAnzSchemeId } = useEnvironmentConfig();

  return (
    <Stack space="large">
      <SectionHeadingLink href="/use-cases/job-posting/job-categories#jobcategory">
        Job category lookup
      </SectionHeadingLink>

      <JobCategoryLookup schemeId={seekAnzSchemeId} />
    </Stack>
  );
};
